import React from "react";
import styles from "./styles.scss";
import { Skeleton } from "@common/skeleton";
import { IndicatorsList } from "./indicatorsList";
import classNames from "classnames";

function Report() {
  return (
    <div className={styles.report}>
      <div className={styles.headerItem}>
        <Skeleton className={styles.submissionDateSkeleton} />
      </div>
      <div className={classNames(styles.headerItem, styles.authorHeader)}>
        <Skeleton className={styles.authorSkeleton} />
        <Skeleton className={styles.nameSkeleton} />
      </div>
      <div className={styles.headerItem}>
        <div className={styles.indicators}>
          <IndicatorsList />
          <IndicatorsList />
          <IndicatorsList />
          <IndicatorsList />
          <IndicatorsList />
        </div>
      </div>
    </div>
  );
}

export { Report };
